document.addEventListener("DOMContentLoaded", function () {
    function attachModalEvents() {
        document.querySelectorAll(".mw_openModal").forEach(button => {
            button.removeEventListener("click", openModal);
            button.addEventListener("click", openModal);
        });
    }

    function openModal(event) {
        event.preventDefault();

        let modalId = this.getAttribute("data-modal");
        let pageHandle = this.getAttribute("data-page");
        let scrollToId = this.getAttribute("data-scroll-to");
        let modal = document.getElementById(modalId);
        let modalTitle = document.getElementById("mw_modalTitle");
        let modalContent = document.getElementById("mw_modalContent");

        if (!modal || !modalTitle || !modalContent) {
            console.error("Modal structure is missing required elements.");
            return;
        }

        modalTitle.textContent = "";
        modalContent.innerHTML = "<p>Loading...</p>";

        fetch(`/pages/${pageHandle}`)
            .then(response => response.text())
            .then(data => {
                let parser = new DOMParser();
                let doc = parser.parseFromString(data, "text/html");

                let contentElement = doc.querySelector(".page-width.page-content");
                if (contentElement) {
                    // NEW: Read title from the hidden span
                    let rawTitle = contentElement.querySelector("#mw_pageTitleData");
                    if (rawTitle && rawTitle.dataset.title) {
                        modalTitle.textContent = rawTitle.dataset.title.trim();
                    } else {
                        modalTitle.textContent = "Example Lesson Extensions";
                    }

                    let sectionHeader = contentElement.querySelector("header.section-header");
                    if (sectionHeader) sectionHeader.remove();

                    // ✅ Optional: still show banner if meta tag exists
                    let bannerMeta = doc.querySelector('meta[name="banner"]');
                    if (bannerMeta) {
                        let bannerImageUrl = bannerMeta.getAttribute("content");
                        if (bannerImageUrl) {
                            let bannerImage = document.createElement("img");
                            bannerImage.src = bannerImageUrl;
                            bannerImage.alt = "Banner";
                            bannerImage.style.display = "block";
                            bannerImage.style.marginBottom = "20px";
                            contentElement.insertBefore(bannerImage, contentElement.firstChild);
                        }
                    }

                    contentElement.style.marginTop = "0";
                    contentElement.style.paddingTop = "0";

                    modalContent.innerHTML = contentElement.innerHTML;

                    let fullPageLink = document.createElement("p");
                    fullPageLink.innerHTML = `<a href="/pages/${pageHandle}" target="_blank" class="mw_modal-footer-link">View Full Page</a>`;
                    modalContent.appendChild(fullPageLink);

                    if (scrollToId) {
                        setTimeout(() => {
                            let targetElement = modalContent.querySelector(`#${scrollToId}`);
                            if (targetElement) {
                                targetElement.style.scrollMarginTop = "100px";
                                targetElement.scrollIntoView({ behavior: "smooth", block: "start" });
                                targetElement.style.backgroundColor = "yellow";
                                targetElement.style.transition = "background-color 1.5s ease-out";

                                setTimeout(() => {
                                    targetElement.style.backgroundColor = "transparent";
                                }, 3000);
                            }
                        }, 200);
                    }
                } else {
                    modalTitle.textContent = "Error";
                    modalContent.innerHTML = "<p>Content not found.</p>";
                }
            })
            .catch(error => {
                modalTitle.textContent = "Error";
                modalContent.innerHTML = "<p>Failed to load content.</p>";
                console.error("Error loading content:", error);
            });

        modal.style.display = "block";
        document.body.style.overflow = "hidden";
        modal.setAttribute("tabindex", "-1");
        modal.focus();
        function escListener(e) {
            if (e.key === "Escape" || e.keyCode === 27) {
                closeModal({ target: modal });
            }
        }
        modal.addEventListener("keydown", escListener);
        modal._escListener = escListener;
    }

    function closeModal(event) {
        let modal = event.target.closest(".mw_modal");
        if (modal) {
            modal.style.display = "none";
            document.body.style.overflow = "auto";
            if (modal._escListener) {
                modal.removeEventListener("keydown", modal._escListener);
                delete modal._escListener;
            }
        }
    }

    attachModalEvents();

    document.addEventListener("click", function (event) {
        if (event.target.closest(".mw_openModal")) {
            openModal.call(event.target.closest(".mw_openModal"), event);
        }
    });

    document.addEventListener("mwContentLoaded", function () {
        attachModalEvents();
    });

    document.querySelectorAll(".mw_close-modal").forEach(closeButton => {
        closeButton.addEventListener("click", closeModal);
    });

    window.addEventListener("click", function (event) {
        document.querySelectorAll(".mw_modal").forEach(modal => {
            if (event.target === modal) {
                modal.style.display = "none";
                document.body.style.overflow = "auto";
            }
        });
    });
});
